<template>
  <button
    class="sound-button"
    :class="{ 'playing': isPlaying }"
    @click.stop="toggleSound"
  >
    <div class="sound-button__wrapper">
      <div class="sound-button__content">
        <div class="sound-button__text">
          <h3 v-if="title" class="h5 font-bold sound-button__title">
            {{ title }}
          </h3>
          <p v-if="text" class="font-btn font-normal sound-button__subtitle">
            {{ text }}
          </p>
        </div>
        <img class="sound-button__waveform" src="../assets/img/soundwaves.gif" />
      </div>
      <div class="sound-button__icon">
        <img class="sound" src="../assets/img/soundplay.gif" />
        <img class="play" src="../assets/img/playcircle.svg" />
        <img class="stop" src="../assets/img/stopcircle.svg" />
      </div>
    </div>
    <audio ref="sound-button-audio" loop>
      <source :src="audio ? audio.url : ''" type="audio/mpeg">
    </audio>
  </button>
</template>

<script>
export default {
  name: 'SoundButton',
  props: {
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    audio: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isPlaying: false
    }
  },
  methods: {
    toggleSound() {
      this.isPlaying = !this.isPlaying

      if (this.isPlaying) {
        this.playSound()
      } else {
        this.stopSound()
      }
    },
    playSound() {
      const audioRef = this.$refs['sound-button-audio']
      if (audioRef) {
        audioRef.play()
      }
    },
    stopSound() {
      const audioRef = this.$refs['sound-button-audio']
      if (audioRef) {
        audioRef.pause()
        audioRef.currentTime = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sound-button {
  padding: 2rem 3rem;
  border-radius: 1rem;
  background: linear-gradient(135deg, #023497, #011131);
  border: none;
  color: white;
  text-align: left;

  &__wrapper {
    display: flex;
    align-items: center;
    gap: 3rem;
  }

  &__content {
    position: relative;
    flex: 1;
  }

  &__text {
    position: absolute;
    top: 0;
    opacity: 1;
    transition: opacity 0.3s ease;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.5rem;
    height: 100%;
  }

  &__title, &__subtitle {
    margin: 0;
  }

  &__waveform {
    opacity: 0;
    margin: 0 auto;
    transition: opacity 0.3s ease;
  }

  &__icon {
    position: relative;
    height: 5rem;
    width: 5rem;

    & .sound {
      opacity: 1;
      position: absolute;
      left: 0;
      transition: opacity 0.3s ease;
    }

    & .play {
      opacity: 0;
      position: absolute;
      left: 0;
      transition: opacity 0.3s ease;
    }

    & .stop {
      opacity: 0;
      position: absolute;
      left: 0;
      transition: opacity 0.3s ease;
    }
  }

  &:hover .sound-button__icon {
    & .sound {
      opacity: 0;
    }

    & .play {
      opacity: 1;
    }
  }

  &.playing {
    .sound-button {
      &__icon {
        & .sound {
          opacity: 0;
        }

        & .play {
          opacity: 0;
        }

        & .stop {
          opacity: 1;
        }
      }

      &__waveform {
        opacity: 1;
      }

      &__text {
        opacity: 0;
      }
    }
  }
}
</style>
